<template>
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >

        <!--:libraryId="libraryId"-->

    </div>
</template>

<script>
    import Pagination from '../../components/pagination'
    import http from '../../APIService/http'
    import {bus} from '../../router/index.js'
    import http2 from '../../APIService/http2'


    export default {
        data() {
            return {
                loading: false,
            }
        },
        created() {


        },
        mounted() {

        },
        watch: {
//            tab:function(newV,oldV){
//
//                if((oldV==='视频' || oldV==='音频')){
//                    this.$refs['form'].clearValidate();
//                }
//            }
        },
        components: {
            Pagination,
        },
        computed: {

        },
        methods: {

        },
        updated() {

        }
    }

    const downloadFile = (url) => {
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";  // 防止影响页面
        iframe.style.height = 0;  // 防止影响页面
        iframe.src = url;
        document.body.appendChild(iframe);  // 这一行必须，iframe挂在到dom树上才会发请求
        // 5分钟之后删除（onload方法对于下载链接不起作用，就先抠脚一下吧）
        setTimeout(() => {
            iframe.remove();
        }, 1 * 60 * 1000);
    }

</script>
<style lang="scss" module scoped>



</style>
<style scoped>

</style>
<style>


</style>




// WEBPACK FOOTER //
// src/pages/target/index.vue